const nist800171Tooltip =
  'Protecting Controlled Unclassified Information in Nonfederal Systems and Organizations';

export default nist800171Tooltip;
